<template>

  <div slot="pageContent">

    <b-row>
      <div class="ml-2 mb-5 alert d-flex align-items-center" disabled role="alert" style="color: #000000;background-color: rgb(236,236,236);">
        {{ $t('entities_setting_tb.description.requester') }}
      </div>
    </b-row>

    <web-service-credential-form
        v-if="displayWeb"
        @validity-changed="isFormValid = $event"
        @cn-create="updateExtractDataFromHeader"
        v-model="config"
        :readonly="!editMode"
        :mode="mode"
        :tb="tb"
        :CertificatServer="CertificatServer"
        :PrivateKeyServer="PrivateKeyServer"
        :CAServer="CAServer"></web-service-credential-form>
    <b-row class="justify-content-end">
      <b-col cols="2" v-if="mode === 'create' && demo">
        <b-button v-if="mode === 'create'"
                  @click="createConfig" variant="primary">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-col>
      <b-col cols="2" v-if="mode === 'details' && editMode === false && canEditConfig && demo">
        <b-button variant="primary"
                  @click="editModeActivate">
          <i class="fa-light fa-pencil"></i>
          <span>{{ $t('administration.edit') }}</span>
        </b-button>
      </b-col>
      <b-col cols="2" v-if="mode === 'details' && editMode === false && canDeleteConfig && demo">
        <b-button variant="primary"
                  @click="deleteConfig">
          <i class="fa-light fa-trash"></i>
          <span>{{ $t('rights.delete') }}</span>
        </b-button>
      </b-col>
      <b-col cols="2" v-if="mode === 'details' && editMode === true && demo">
        <b-button variant="primary"
                  :disabled="!isFormValid"
                  @click="editConfig">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"

import {loadPage} from '@/helpers/routing'
import WebServiceCredentialForm from "@/pages/routing/WebServiceCredentialForm.vue"

import conf from '../../config/config.dev.js'

export default {
  name: 'WebServiceCredentialDetailsTB',
  components: {
    'back-button': backButton,
    'page-outline': PageOutline,
    'web-service-credential-form': WebServiceCredentialForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    entitiesType: {
      type: String,
      default: "rvm"
    },
    s3: {
      type: String,
      default: ""
    },
    tb: {
      type: String,
      default: "0"
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.rights.rightIs('webServiceConfig_delete', true)
    },
    canEditConfig () {
      return this.$engine.rights.rightIs('webServiceConfig_edit', true)
    },
    pageTitle () {
      return this.mode === 'details' ? this.$t('Webheader.webservice_details') : this.$t('Webheader.webservice_add')
    },
  },
  data () {
    return {
      isFormValid: false,
      activateSpinner: false,
      config: {},
      editMode: false,
      displayWeb: false,
      demo: true,
      returnUrl: '',
      CAServer: '',
      CertificatServer: '',
      PrivateKeyServer: '',
      savedConfig: [],
      realHost: '',
      realPort: ''
    }
  },
  created () {
    if (this.tb == 1) {
      this.returnUrl = `/entitiessettingsTB/`

      let that = this

      let params = {}
      params.IdAccountTB = 1

      this.$engine.routing.config.webService.fetch(params).then(resp => {
        let webServiceList = {}

        webServiceList = resp?.data?.WebServiceCredentials?.length ? resp.data.WebServiceCredentials[0] : {}
        webServiceList.Country = resp.data.Country == '$NotFound' ? '' : resp.data.Country
        webServiceList.OrganisationIdentifier = resp.data.OrganisationIdentifier == '$NotFound' ? '' : resp.data.OrganisationIdentifier
        webServiceList.CertType = resp.data.CertType == '$NotFound' ? '' : resp.data.CertType
        webServiceList.ACFile = resp.data.ACClient == '$NotFound' ? '' : resp.data.ACClient

        if (this.mode === 'details') {
          this.savedConfig = webServiceList
          this.fillFields()
        } else {
          this.editMode = true
        }

        // Extraction des certificats encodés en Base64
        const base64Certs = [
          resp.data.Certificate1,
          resp.data.Certificate2,
          resp.data.CertificateClient,
          resp.data.PrivateKeyClient
        ]

        const cleanPem = (pem) => {
          try {
            let cleaned = atob(pem);
            // Enlève les guillemets autour s’ils existent
            if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
              cleaned = cleaned.slice(1, -1);
            }
            cleaned = cleaned.replace(/\\n/g, '\n');
            return cleaned;
          } catch (e) {
            console.error('Invalid base64:', pem);
            return '';
          }
        };

        const certServerPem = cleanPem(base64Certs[2])
        const privateKeyServerPem = cleanPem(base64Certs[3])
        const caCertPem1 = cleanPem(base64Certs[1])
        const caCertPem2 = cleanPem(base64Certs[0])

        // Stocker les certificats
        this.CertificatServer = certServerPem
        this.PrivateKeyServer = privateKeyServerPem
        this.CAServer = `${caCertPem1}\n${caCertPem2}`

        this.$f7.initPullToRefresh()
        this.activateSpinner = false

        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
          .catch(error => {
            errorMessageAlert(error, that)
          })
    }else{

      if (this.s3 != 'webservice') {
        this.role = this.$route.query.role
        this.type = this.$route.query.type
        this.returnUrl = `/routing/configlist/${this.role}/${this.type}/${this.entitiesType}`
        this.activateSpinner = true

        if (this.mode === 'details') {
          this.savedConfig = this.$engine.routing.config.clickedConfig
          this.fillFields()
          this.$engine.routing.config.clickedConfig = {}
        } else {
          this.editMode = true
        }

        this.$f7.initPullToRefresh()
        this.activateSpinner = false
      }
      else{
        this.returnUrl = '/entitiessettings/decentralised/SI'
        let params = { Role: 1, entityType : 2, messageType : 3 }
        let that = this

        if (this.mode === 'details') {
          this.$engine.routing.config.webService.fetch(
              params
          )
              .then(resp => {
                this.savedConfig = resp.data.WebServiceCredentials[0]
                this.fillFields()
                this.$engine.routing.config.clickedConfig = {}
                this.$f7.initPullToRefresh()
                this.activateSpinner = false
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })

        } else {
          this.editMode = true
          this.$f7.initPullToRefresh()
          this.activateSpinner = false
        }
      }
    }

  },
  watch: {
    Cert: {
      deep: true,
      handler(val) {
        this.$emit('input', this.inputValue)
      }
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    updateExtractDataFromHeader(value){
      if (value){
        this.config.ExtractDataFromHeader = value

      }else{
        const prefix = "PSDFR-ACPR-"
        this.config.ExtractDataFromHeader = this.config.OrganisationIdentifierData.startsWith(prefix) ? this.config.OrganisationIdentifierData : prefix + this.config.OrganisationIdentifierData
      }
    },
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive === '1') {
        let paramsControl = {
          selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: 'SSL',
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          deliveredBy: this.config.certificateConfig.deliveredBy,
          deliveredTo: this.config.certificateConfig.deliveredTo,
          commonName: this.config.certificateConfig.cn,
          idPod: this.config.certificateConfig.idPod,
          ExtractDataFromCertificat: this.config.certificateConfig.ExtractDataFromCertificat,
          IdAuthCert: this.config.certificateConfig.IdAuthCert,
          ExtractDataFromHeader: this.config.certificateConfig.ExtractDataFromHeader,
          IdAuthHeader: this.config.certificateConfig.IdAuthHeader
        }

        this.$engine.security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: that.config.privateKeysConfig.name,
            privateKey: that.config.privateKeysConfig.privateKey,
            password: that.config.privateKeysConfig.password,
            passwordVerif: that.config.privateKeysConfig.passwordVerif,
            type: that.config.privateKeysConfig.type,
            idPod: that.config.privateKeysConfig.idPod
          }
          let params = {
            idCertificat: respCertificate.data.idCertificat
          }

          that.$engine.security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            params.Host = that.config.host
            params.Port = that.config.port
            params.URI = that.config.uri
            params.SSLMode = that.config.sslActive
            params.Name = that.config.name
            params.idPrivateKey = respPrivateKey.data.idPrivateKey
            that.$engine.routing.config.webService.create(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.routing.config_added'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: this.returnUrl})
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      } else {
        let params = {
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          login: this.config.login,
          password: this.config.password
          //idCertificate: respCertificate.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          //idPrivateKey: respPrivateKey.data.id
        }
        this.$engine.routing.config.webService.create(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: this.returnUrl})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      }
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdWebService: that.savedConfig.IdWebService
              }
              that.$engine.routing.config.webService.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive !== '0') {

        let modeSecurity = this.getmodeSecurity()

        const country = this.config.Country != undefined ? this.config.Country.toUpperCase() : undefined
        let params = {
          Type: 'Credential',
          Timeout: this.config.timeout,
          Host: this.realHost,
          Port: this.realPort,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Keystore: this.config.keystore,
          CA: this.config.ca,
          Name: this.config.name,
          ExtractDataFromHeader: this.config.ExtractDataFromHeader,
          OrganisationIdentifier: this.config.OrganisationIdentifier,
          IdWebService: this.savedConfig.IdWebService,
          login: this.config.login,
          password: this.config.password,
          ModeSecurity: modeSecurity,
          IdVopProvider: this.config.IdVopProvider,
          Country: country,
          TBFlag: 1,
          updateMessageRouting: 1,
          CertType: this.config.CertType,
          ...(this.config.ACFile ? { ACFile: this.config.ACFile } : {})
        }

        if (that.config.Cert) {
          params.Certificate = that.config.Cert.Cert
          params.Key = that.config.Cert.Key
        }

        this.$engine.routing.config.webService.edit(params)
        .then(resp => {
          that.editMode = false
          that.$f7.modal({
            title: this.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: this.returnUrl})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          this.okMessageBox(this.$t('common.routing.config_edition_error'))
        })
            /*let paramsControl = {
            selectedVerifications: this.config.controlConfig.selectedVerif
            }

            let paramsCertif = {
              name: this.config.certificateConfig.name,
              certificate: this.config.certificateConfig.certificate,
              type: this.config.certificateConfig.type,
              password: this.config.certificateConfig.password,
              passwordVerif: this.config.certificateConfig.passwordVerif,
              startDate: this.config.certificateConfig.startDate,
              endDate: this.config.certificateConfig.endDate,
              commonName: this.config.certificateConfig.cn
              //idCertificate: this.savedConfig.idCertificate DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
            }
            this.$engine.security.certificates.create(paramsCertif)
            .then(respCertificate => {
              let paramsPrivateKey = {
                name: this.config.privateKeysConfig.name,
                privateKey: this.config.privateKeysConfig.privateKey,
                password: this.config.privateKeysConfig.password,
                passwordVerif: this.config.privateKeysConfig.passwordVerif,
                type: this.config.privateKeysConfig.type
                //idPrivateKey: respPrivateKey.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
              }
              this.$engine.security.private_keys.create(paramsPrivateKey)
              .then(respPrivateKey => {
                let params = {
                  Host: this.config.host,
                  Port: this.config.port,
                  URI: this.config.uri,
                  SSLMode: this.config.sslActive,
                  Name: this.config.name,
                  IdWebService: this.savedConfig.IdWebService
                }
                this.$engine.routing.config.webService.edit(params)
                .then(resp => {
                  that.$f7.modal({
                    title: this.$t('common.routing.config_edited'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                  loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
                })
              })
            })*/
      } else {
        let params = {
          Type: 'Credential',
          Timeout: this.config.timeout,
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          IdWebService: this.savedConfig.IdWebService,
          login: this.config.login,
          password: this.config.password,
          ...(this.config.keystore ? { Keystore: this.config.keystore } : {}),
          ...(this.config.ca ? { CA: this.config.ca } : {}),
          IdVopProvider: this.config.IdVopProvider,
          TBFlag: 1
        }

        if (that.config.Cert) {
          params.Certificate = that.config.Cert.Cert
          params.Key = that.config.Cert.Key
        }

        this.$engine.routing.config.webService.edit(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: this.returnUrl})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_edition_error'))
        })
      }
    },
    editModeActivate () {
      this.editMode = true
    },
    getmodeSecurity () {
      let modeSecurity = 0
      if (this.config?.controlConfig?.selectedVerif && Array.isArray(this.config.controlConfig.selectedVerif)) {
        if (this.config.controlConfig.selectedVerif.length !== 0) {
          let dictionnary = {
            listVerifClientSSL: {
              1: { id: 1, text: this.$i18n.t('common.global.verify_peer'), value: 1 },
              2: { id: 2, text: this.$i18n.t('common.global.ctrl_CRL'), value: 32 },
              3: { id: 3, text: this.$i18n.t('common.global.ctrl_key_usage'), value: 8 },
              4: { id: 4, text: this.$i18n.t('common.global.ctrl_key_size'), value: 16 },
              5: { id: 5, text: this.$i18n.t('common.global.ctrl_expiration'), value: 1024 },
              6: { id: 6, text: this.$i18n.t('common.global.ctrl_CN'), value: 2048 }
            },
            listVerifServerSSL: {
              7: { id: 7, text: this.$i18n.t('common.global.ctrl_CA'), value: 2 },
              8: { id: 8, text: this.$i18n.t('common.global.ctrl_CRL'), value: 256 },
              9: { id: 9, text: this.$i18n.t('common.global.ctrl_key_usage'), value: 64 },
              10: { id: 10, text: this.$i18n.t('common.global.ctrl_key_size'), value: 128 },
              11: { id: 11, text: this.$i18n.t('common.global.ctrl_expiration'), value: 512 },
              12: { id: 12, text: this.$i18n.t('common.global.ctrl_CN'), value: 4096 }
            }
          }


          this.config.controlConfig.selectedVerif.forEach(element => {
            if (element > 6) {
              modeSecurity += dictionnary.listVerifServerSSL[element].value
            } else {
              modeSecurity += dictionnary.listVerifClientSSL[element].value
            }
          })
        }
      }


      return modeSecurity
    },
    fillFields () {
      this.realHost = this.savedConfig.Host
      this.realPort = this.savedConfig.Port
      this.config.timeout = this.savedConfig.Timeout
      this.config.host = conf.apientry && conf.apientry.host_apientry ? conf.apientry.host_apientry : this.savedConfig.Host
      this.config.formatName = this.savedConfig.FormatName
      this.config.formatOutName = this.savedConfig.FormatOutName
      this.config.name = this.savedConfig.Name
      this.config.keystore = this.savedConfig.Keystore
      this.config.ca = this.savedConfig.CA
      this.config.port = conf.apientry && conf.apientry.port_apientry ? conf.apientry.port_apientry : this.savedConfig.Port
      this.config.uri = this.savedConfig.URI
      this.config.sslActive = this.savedConfig.SSLMode
      this.config.login = this.savedConfig.Login
      this.config.password = this.savedConfig.Password
      this.config.controlConfig = this.savedConfig.controlConfig
      this.config.ExtractDataFromCertificat = this.savedConfig.ExtractDataFromCertificat
      this.config.IdAuthCert = this.savedConfig.IdAuthCert
      this.config.ExtractDataFromHeader = this.savedConfig.ExtractDataFromHeader
      this.config.IdAuthHeader = this.savedConfig.IdAuthHeader
      this.config.IdVopProvider = this.savedConfig.IdVopProvider
      this.config.Cert = this.savedConfig.Cert
      this.config.Key = this.savedConfig.Key
      this.config.ACFile = this.savedConfig.ACFile
      this.config.Country = this.savedConfig.Country
      this.config.OrganisationIdentifier = this.savedConfig.OrganisationIdentifier
      this.config.CertType = this.savedConfig.CertType

      this.displayWeb = true
    },
    formHasError () {
      if (this.config.host === undefined || this.config.host.length === 0) {
        this.okMessageBox(this.$t('common.routing.host_missing'))
        return true
      }
      if (this.config.port === undefined || this.config.port.length === 0) {
        this.okMessageBox(this.$t('common.routing.port_missing'))
        return true
      }
      // if (this.config.uri === undefined || this.config.uri.length === 0) {
      //   this.okMessageBox(this.$t('common.routing.uri_missing'))
      //   return true
      // }
      if (this.config.Country && ![2,3].includes(this.config.Country.length)) {
        this.okMessageBox(this.$t('common.routing.country_code_length'))
        return true
      }
      if (this.config.sslActive !== '0') {
        if (this.config.keystore === undefined || this.config.keystore.length === 0) {
          this.okMessageBox(this.$t('common.routing.keystore'))
          return true
        }
        /* if (this.config.ca === undefined || this.config.ca.length === 0) {
          this.okMessageBox(this.$t('common.routing.truststore'))
          return true
        } */
        /*if (this.config.controlConfig === undefined || this.config.controlConfig.selectedVerif.length === 0) {
          this.okMessageBox(this.$t('common.global.ctrl_missing'))
          return true
        }
        if (this.config.certificateConfig === undefined) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.name === undefined || this.config.certificateConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.certificate === undefined || this.config.certificateConfig.certificate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_desc_missing'))
          return true
        }
        if (this.config.certificateConfig.type === undefined || this.config.certificateConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.certif_type_missing'))
          return true
        }
        if (this.config.certificateConfig.password === undefined || this.config.certificateConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.certificateConfig.passwordVerif === undefined || this.config.certificateConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }
        if (this.config.certificateConfig.startDate === undefined || this.config.certificateConfig.startDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_valid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.endDate === undefined || this.config.certificateConfig.endDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_unvalid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.cn === undefined || this.config.certificateConfig.cn.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_cn_missing'))
          return true
        }
        if (this.config.privateKeysConfig === undefined) {
          this.okMessageBox(this.$t('common.securityffff'))
          return true
        }
        if (this.config.privateKeysConfig.name === undefined || this.config.privateKeysConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_name_missing'))
          return true
        }
        if (this.config.privateKeysConfig.privateKey === undefined || this.config.privateKeysConfig.privateKey.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
          return true
        }
        if (this.config.privateKeysConfig.type === undefined || this.config.privateKeysConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.priv_key_type_missing'))
          return true
        }
        if (this.config.privateKeysConfig.password === undefined || this.config.privateKeysConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.privateKeysConfig.passwordVerif === undefined || this.config.privateKeysConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }*/
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: this.returnUrl})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
